import React, { useState, useEffect } from 'react';

// Components and others
import clsx from 'clsx';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import Container from 'components/widgets/Container';
import { modules } from 'utils/enum/modules';

import MessageCenterList from 'components/modules/messageCenter/list/MessageCenterList';
import MessageCenterCustomerContext from 'components/context/MessageCenterCustomerContext';
import MessageCenterDetail from 'components/modules/messageCenter/read/MessageCenterDetail';
import ConversationPlaceholder from 'components/modules/conversation/list/ConversationPlaceholder';

// Material UI
import { useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

// Utils
import KeyStore from 'utils/KeyStore';
import Permission from 'utils/enum/Permissions';
import { MEDIA_QUERY } from 'utils/enum/Core';
import CustomerSection from 'components/modules/messageCenter/list/CustomerSection';
import MessageCenterLayoutStyle from 'styles/modules/crm/MessageCenterLayoutStyle';

const keyStore = new KeyStore();
const useStyles = makeStyles((theme) => MessageCenterLayoutStyle.content(theme));

const MessageCenter = () => {
    const classes = useStyles();
    const history = useHistory();
    const { id } = useParams();
    const isMobile = useMediaQuery(`(max-width:${MEDIA_QUERY.W_430}px)`);
    const [customer, setCustomer] = useState({});
    const [showDetail, setShowDetail] = useState(false);

    const location = useLocation();
    const query = new URLSearchParams(location.search || '');
    const smsRead = query.get('smsRead');

    useEffect(() => {
        if (id && isMobile) {
            setShowDetail(true);
        } else if (!id && isMobile) {
            setShowDetail(false);
        }
    }, [id, isMobile]);

    const handleBackToList = () => {
        setShowDetail(false);
        history.push(`/${modules.COMMUNICATION}/sms`);
    };

    const renderConversationDetails = () => {
        if (id && customer?.customerId) {
            return (
                <>
                    <div className={clsx(classes.detail, isMobile && !showDetail && classes.detailHidden)}>
                        <MessageCenterDetail
                            smsChatId={id}
                            customer={customer}
                            smsRead={smsRead}
                            onBackToList={isMobile ? handleBackToList : null}
                        />
                    </div>
                    <CustomerSection customer={customer} />
                </>
            );
        }

        return (
            !isMobile && <ConversationPlaceholder />
        );
    };

    return (
        <div className={classes.main}>
            <MessageCenterCustomerContext.Provider value={{ customer, setCustomer }}>
                <Container padding={false} backgroundColor={false}>
                    {keyStore.hasPermission(Permission.CRM_MESSAGE_CENTER_READ) && (
                        <div className={clsx(classes.listContainer, isMobile && showDetail && classes.listHidden)}>
                            <MessageCenterList conversationId={id} />
                        </div>
                    )}
                    {keyStore.hasPermission(Permission.CRM_MESSAGE_CENTER_READ) && renderConversationDetails()}
                </Container>
            </MessageCenterCustomerContext.Provider>
        </div>
    );
};

export default MessageCenter;
